import type { MapEngine } from '@mighty-map/map-engine';
import { useEffect, useState } from 'react';
import { scaleBar, type ScaleBarSpec } from '../../lib/scaleBar';

const MAX_WIDTH_PX = 100;

/** Metric scale bar, bottom left; recomputed from zoom and latitude each time the camera settles. */
export function ScaleBar({ engine }: { engine: MapEngine | null }) {
  const [spec, setSpec] = useState<ScaleBarSpec | null>(null);
  useEffect(() => {
    if (!engine) return;
    const update = (): void => {
      const cam = engine.getCamera();
      setSpec(scaleBar(cam.zoom, cam.center[1], MAX_WIDTH_PX));
    };
    update();
    return engine.onCameraChange(update);
  }, [engine]);
  if (!spec) return null;
  return (
    <div className="mm-scalebar" aria-label={`Scale: ${spec.label}`} role="img">
      <div>{spec.label}</div>
      <div className="mm-scalebar-line" style={{ width: spec.widthPx }} />
    </div>
  );
}
